import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function ComplianceSuggestDialog({ emp, onClose }) {
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState({});
  useEffect(() => {
    if (!emp) return;
    setRows([]);
    setSel({});
    api.get(`/compliance/suggestions/employee/${emp.id}`).then((r) => { setRows(r.data); setSel(Object.fromEntries(r.data.filter((s) => !s.already).map((s) => [s.title, true]))); }).catch(() => onClose());
  }, [emp]); // eslint-disable-line react-hooks/exhaustive-deps
  const go = async () => {
    try { const r = await api.post(`/compliance/suggestions/employee/${emp.id}/accept`, { titles: Object.keys(sel).filter((k) => sel[k]) }); toast.success(`${r.data.created} obligation(s) ajoutée(s) au registre, à qualifier`); onClose(); }
    catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <Dialog open={!!emp} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto rounded-3xl sm:max-w-lg" data-testid="comp-suggest">
        <DialogHeader><DialogTitle className="font-display">Obligations à prévoir pour {emp?.first_name} {emp?.last_name}</DialogTitle></DialogHeader>
        <p className="text-xs text-gray-500">Propositions issues de la fiche (embauche, poste, contrat). Elles seront ajoutées au registre « Conformité & Contrôles » au statut « À qualifier », sans être validées.</p>
        <div className="space-y-2">{rows.map((s) => (
          <label key={s.title} className={`flex items-start gap-2 rounded-xl border p-2.5 text-sm ${s.already ? "opacity-50" : ""}`} data-testid="comp-suggest-item">
            <input type="checkbox" disabled={s.already} checked={!!sel[s.title]} onChange={(e) => setSel({ ...sel, [s.title]: e.target.checked })} className="mt-1 accent-[#065F46]" />
            <span><b>{s.title}</b><span className="block text-xs text-gray-400">{s.nature === "conditionnelle" ? "Conditionnelle" : "Obligatoire"}{s.next_due ? ` · échéance proposée ${fmtDate(s.next_due)}` : ""}{s.already ? " · déjà au registre" : ""}</span></span>
          </label>))}</div>
        <div className="flex justify-end gap-2"><Button variant="outline" className="rounded-full" onClick={onClose} data-testid="comp-suggest-skip">Plus tard</Button>
          <Button data-testid="comp-suggest-accept" className="rounded-full bg-[#065F46] hover:bg-[#047857]" onClick={go}>Ajouter la sélection</Button></div>
      </DialogContent>
    </Dialog>
  );
}
